import { ReactElement } from "react";
import { mediaUrlWithCacheBust } from "../../utils/mediaUrl";
import { logLessonMediaLoadFailure } from "../../utils/clientDiagnosticLog";

interface IProps {
  id?: number;
  url?: string;
  cacheBust?: number;
  onClickNextEx: () => void;
}

export function VideoLesson(props: IProps): ReactElement {
  const videoSrc = mediaUrlWithCacheBust(
    props.url == null || props.url === "" ? "" : props.url.startsWith("/") ? props.url : `/${props.url}`,
    props.cacheBust ?? 0
  );
  return (
    <>
      <video
        className="mainPage_VideoPad"
        loop
        autoPlay
        key={videoSrc}
        onError={(e) => {
          const err = e.currentTarget.error;
          logLessonMediaLoadFailure({
            kind: "video",
            src: videoSrc,
            exerciseId: props.id,
            mediaErrorCode: err?.code ?? null,
            mediaErrorMessage: err?.message ?? null,
          });
        }}
      >
        <source src={videoSrc} type="video/mp4" />
      </video>

      <div className="lessonPageOnward-button" onClick={()=>props.onClickNextEx()}>
        Далее
      </div>
    </>
  );
}
